import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useHistory } from "react-router-dom";
import {
  BANNER_IMAGES_ARR,
  IMAGE_CACHE_URL_BANNER,
} from "../../../config/Constant";
import { Carousel } from "react-responsive-carousel";

const CarouselBanner = () => {
  const history = useHistory();

  const handleCarouselClick = (index) => {
    if (index === 0) {
      history.push("/group/66644c6e84ea229fc8ee4ec9");
    } else if (index === 1) {
      history.push("/group/66644f0f3b181ed7d8251df6");
    }
  };

  return (
    <div className="container mobile-container">
      <Carousel 
        autoPlay 
        infiniteLoop 
        showIndicators={false} 
        showThumbs={false}
        onClickItem={handleCarouselClick}
      >
        {BANNER_IMAGES_ARR.map((element, i) => (
          <div 
            key={i} 
            style={{ cursor: i === 0 ? "pointer" : "default" }}
            onClick={() => i === 0 && history.push("/group/66644c6e84ea229fc8ee4ecf")}
          >
            <img
              className="banner-image"
              src={IMAGE_CACHE_URL_BANNER + element}
              alt="banner"
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CarouselBanner;
